/**
 * Форматирует время в секундах в читаемый формат
 * @param seconds - количество секунд
 * @param translations - объект с переводами
 * @returns отформатированная строка времени
 */
export function formatTime(seconds: number, translations?: { 'label-seconds-short': string; 'label-minute': string }): string {
  const secondsShort = translations?.['label-seconds-short'] || 'с';
  const minuteShort = translations?.['label-minute'] || 'мин';
  
  if (seconds < 60) {
    return `${seconds}${secondsShort}`;
  }
  
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  
  if (remainingSeconds === 0) {
    return `${minutes}${minuteShort}`;
  }
  
  return `${minutes}${minuteShort} ${remainingSeconds}${secondsShort}`;
}